import { Tag } from 'antd'
import type { McpPlaybookSummary } from '@/types/mcp'

export default function PlaybookTags({ playbook }: { playbook: Pick<McpPlaybookSummary, 'scope' | 'adminOnly'> }) {
  return (
    <>
      {playbook.scope === 'firmEdit' && (
        <Tag color="cyan" className="!m-0">
          Edited by your firm
        </Tag>
      )}
      {playbook.adminOnly && (
        <Tag color="gold" className="!m-0">
          Admins
        </Tag>
      )}
    </>
  )
}
